"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonHeader = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const lu_1 = require("react-icons/lu");
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const AppLauncher_1 = require("../AppLauncher");
const BranchesModal_1 = require("../BranchesModal");
const InvoicesModal_1 = require("../InvoicesModal");
function initials(name) {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => { var _a; return (_a = part[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase(); })
        .join("");
}
const OktonHeader = ({ onOpenSidebar, onLogout, onProfile, onInvoices, onChangeBranch, onSettings, }) => {
    const { system, user, businessContext, client, theme, setTheme, features } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const [profileOpen, setProfileOpen] = (0, react_2.useState)(false);
    const [searchOpen, setSearchOpen] = (0, react_2.useState)(false);
    const [mobile, setMobile] = (0, react_2.useState)(false);
    const [settingsOpen, setSettingsOpen] = (0, react_2.useState)(false);
    const [profileModalOpen, setProfileModalOpen] = (0, react_2.useState)(false);
    const [invoicesOpen, setInvoicesOpen] = (0, react_2.useState)(false);
    const [branchesOpen, setBranchesOpen] = (0, react_2.useState)(false);
    const [query, setQuery] = (0, react_2.useState)("");
    const [results, setResults] = (0, react_2.useState)([]);
    const [searching, setSearching] = (0, react_2.useState)(false);
    const timer = (0, react_2.useRef)();
    (0, react_2.useEffect)(() => {
        const update = () => setMobile(window.innerWidth < 1024);
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);
    (0, react_2.useEffect)(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
                event.preventDefault();
                setSearchOpen(true);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);
    (0, react_2.useEffect)(() => {
        window.clearTimeout(timer.current);
        if (!query.trim() || !client) {
            setResults([]);
            setSearching(false);
            return;
        }
        timer.current = window.setTimeout(() => {
            setSearching(true);
            client
                .search(query.trim())
                .then((value) => {
                setResults(value);
                setSearching(false);
            })
                .catch(() => {
                setResults([]);
                setSearching(false);
            });
        }, 250);
        return () => window.clearTimeout(timer.current);
    }, [query, client]);
    const dark = theme === "dark";
    const palette = dark
        ? {
            header: "#1A202C",
            panel: "#1F2937",
            panel2: "#273142",
            text: "#F7FAFC",
            muted: "#A0AEC0",
            border: "#4A5568",
            hover: "#2D3748",
        }
        : {
            header: "#3182CE",
            panel: "#FFFFFF",
            panel2: "#F7FAFC",
            text: "#2D3748",
            muted: "#718096",
            border: "#E2E8F0",
            hover: "#EDF2F7",
        };
    const iconButton = {
        width: 36,
        height: 36,
        border: 0,
        borderRadius: 10,
        background: "transparent",
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
    };
    function openSettings() {
        setProfileOpen(false);
        if (onSettings)
            onSettings();
        else
            setSettingsOpen(true);
    }
    function openProfile() {
        setProfileOpen(false);
        if (onProfile)
            onProfile();
        else
            setProfileModalOpen(true);
    }
    function openInvoices() {
        setProfileOpen(false);
        if (onInvoices)
            onInvoices();
        else if (features.billing && (client === null || client === void 0 ? void 0 : client.getInvoices))
            setInvoicesOpen(true);
    }
    function openBranches() {
        setProfileOpen(false);
        if (onChangeBranch)
            onChangeBranch();
        else if (features.branchSwitching &&
            (client === null || client === void 0 ? void 0 : client.getBranches) &&
            (client === null || client === void 0 ? void 0 : client.switchBranch)) {
            setBranchesOpen(true);
        }
    }
    const canInvoices = Boolean(features.billing && (onInvoices || (client === null || client === void 0 ? void 0 : client.getInvoices)));
    const canBranches = Boolean(features.branchSwitching &&
        (onChangeBranch || ((client === null || client === void 0 ? void 0 : client.getBranches) && (client === null || client === void 0 ? void 0 : client.switchBranch))));
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("header", { style: {
                height: 64,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                padding: "0 24px",
                background: palette.header,
                color: "#fff",
                borderBottom: `1px solid ${dark ? "#2D3748" : "#2B6CB0"}`,
                position: "relative",
                zIndex: 40,
            } },
            mobile ? (react_2.default.createElement("button", { type: "button", "aria-label": "Navega\u00E7\u00E3o", onClick: onOpenSidebar, style: Object.assign(Object.assign({}, iconButton), { marginRight: 8 }) }, react_2.default.createElement(lu_1.LuMenu, { size: 22 }))) : null,
            react_2.default.createElement("div", { style: {
                    width: 256,
                    minWidth: 0,
                    fontSize: 28,
                    fontWeight: 600,
                    letterSpacing: "-.025em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                } },
                system.name,
                react_2.default.createElement("span", { style: { color: "#ECC94B", marginLeft: 4 } }, ".")),
            client && !mobile ? (react_2.default.createElement("button", { type: "button", onClick: () => setSearchOpen(true), style: {
                    height: 40,
                    minWidth: 410,
                    border: "1px solid rgba(255,255,255,.16)",
                    borderRadius: 8,
                    background: "rgba(255,255,255,.10)",
                    color: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 14px",
                    cursor: "pointer",
                } },
                react_2.default.createElement(lu_1.LuSearch, { size: 18 }),
                react_2.default.createElement("span", { style: {
                        flex: 1,
                        marginLeft: 10,
                        textAlign: "left",
                        fontSize: 14,
                    } }, "Buscar na plataforma"),
                react_2.default.createElement("kbd", { style: kbdStyle }, "Ctrl"),
                react_2.default.createElement("span", { style: { margin: "0 5px" } }, "+"),
                react_2.default.createElement("kbd", { style: kbdStyle }, "K"))) : null,
            react_2.default.createElement("div", { style: { flex: 1 } }),
            react_2.default.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    gap: mobile ? 16 : 24,
                    paddingRight: mobile ? 8 : 16,
                } },
                react_2.default.createElement("button", { type: "button", "aria-label": "Alternar tema", onClick: () => void setTheme(dark ? "light" : "dark"), style: iconButton }, react_2.default.createElement((dark ? lu_1.LuMoon : lu_1.LuSun), {
                    size: mobile ? 18 : 22,
                })),
                react_2.default.createElement("button", { type: "button", "aria-label": "Notifica\u00E7\u00F5es", style: iconButton }, react_2.default.createElement(lu_1.LuBell, { size: mobile ? 18 : 22 })),
                react_2.default.createElement(react_1.Menu, { isLazy: true },
                    react_2.default.createElement(react_1.MenuButton, { as: "button", type: "button", "aria-label": "Aplicativos", style: iconButton }, react_2.default.createElement(lu_1.LuGrip, { size: 21 })),
                    react_2.default.createElement(react_1.MenuList, { overflowX: "hidden", position: "absolute", right: "0", top: "0", minW: "350px", bg: palette.panel, color: palette.text, borderColor: palette.border },
                        react_2.default.createElement(react_1.MenuItem, { p: "0", cursor: "default", bg: palette.panel, _hover: { bg: palette.panel } },
                            react_2.default.createElement(AppLauncher_1.OktonAppLauncher, null)))),
                user ? (react_2.default.createElement("div", { style: { position: "relative" } },
                    react_2.default.createElement("button", { type: "button", onClick: () => setProfileOpen((v) => !v), "aria-label": "Perfil", style: {
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            border: 0,
                            background: "#2B6CB0",
                            color: "#fff",
                            fontWeight: 700,
                            cursor: "pointer",
                        } }, initials(user.name || user.email || "OK") || "OK"),
                    profileOpen ? (react_2.default.createElement("div", { style: {
                            position: "absolute",
                            right: 0,
                            top: 44,
                            width: 250,
                            padding: 8,
                            background: palette.panel,
                            color: palette.text,
                            border: `1px solid ${palette.border}`,
                            borderRadius: 12,
                            boxShadow: "0 12px 30px rgba(0,0,0,.18)",
                        } },
                        react_2.default.createElement("div", { style: {
                                padding: "8px 10px 10px",
                                borderBottom: `1px solid ${palette.border}`,
                            } },
                            react_2.default.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, user.name),
                            user.email ? (react_2.default.createElement("div", { style: {
                                    fontSize: 11,
                                    color: palette.muted,
                                    marginTop: 2,
                                } }, user.email)) : null),
                        features.profile !== false ? (react_2.default.createElement("button", { type: "button", onClick: openProfile, style: Object.assign(Object.assign({}, menuButton), { color: palette.text }) },
                            react_2.default.createElement(lu_1.LuUserRound, { size: 16 }),
                            react_2.default.createElement("span", null, "Perfil"))) : null,
                        canInvoices ? (react_2.default.createElement("button", { type: "button", onClick: openInvoices, style: Object.assign(Object.assign({}, menuButton), { color: palette.text }) },
                            react_2.default.createElement(lu_1.LuReceiptText, { size: 16 }),
                            react_2.default.createElement("span", null, "Faturas do Sistema"))) : null,
                        canBranches ? (react_2.default.createElement("button", { type: "button", onClick: openBranches, style: Object.assign(Object.assign({}, menuButton), { color: palette.text }) },
                            react_2.default.createElement(lu_1.LuBuilding2, { size: 16 }),
                            react_2.default.createElement("span", null, "Trocar Filial"))) : null,
                        react_2.default.createElement("button", { type: "button", onClick: openSettings, style: Object.assign(Object.assign({}, menuButton), { color: palette.text }) },
                            react_2.default.createElement(lu_1.LuSettings2, { size: 16 }),
                            react_2.default.createElement("span", null, "Configura\u00E7\u00F5es da conta")),
                        react_2.default.createElement("button", { type: "button", onClick: onLogout, style: Object.assign(Object.assign({}, menuButton), { color: "#C53030", borderTop: `1px solid ${palette.border}`, marginTop: 4 }) }, "Logout"))) : null)) : null)),
        searchOpen ? (react_2.default.createElement("div", { style: {
                position: "fixed",
                inset: 0,
                zIndex: 100,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                padding: "10vh 20px 20px",
            } },
            react_2.default.createElement("button", { type: "button", "aria-label": "Fechar busca", onClick: () => {
                    setSearchOpen(false);
                    setQuery("");
                }, style: {
                    position: "absolute",
                    inset: 0,
                    border: 0,
                    background: "rgba(0,0,0,.48)",
                } }),
            react_2.default.createElement("div", { style: {
                    position: "relative",
                    width: "min(672px, 100%)",
                    maxHeight: "75vh",
                    overflow: "hidden",
                    borderRadius: 16,
                    background: palette.panel,
                    color: palette.text,
                    boxShadow: "0 20px 60px rgba(0,0,0,.28)",
                } },
                react_2.default.createElement("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                        padding: "18px 20px",
                        borderBottom: `1px solid ${palette.border}`,
                    } },
                    react_2.default.createElement(lu_1.LuSearch, {
                        size: 26,
                        color: dark ? "#FFFFFF" : "#3182CE",
                    }),
                    react_2.default.createElement("input", { autoFocus: true, value: query, onChange: (event) => setQuery(event.target.value), placeholder: "Buscar na plataforma", style: {
                            flex: 1,
                            height: 42,
                            border: 0,
                            outline: "none",
                            background: "transparent",
                            color: palette.text,
                            fontSize: 18,
                        } }),
                    react_2.default.createElement("button", { type: "button", "aria-label": "Fechar", onClick: () => {
                            setSearchOpen(false);
                            setQuery("");
                        }, style: Object.assign(Object.assign({}, iconButton), { color: palette.muted }) }, react_2.default.createElement(lu_1.LuX, { size: 20 }))),
                react_2.default.createElement("div", { style: { maxHeight: "55vh", overflowY: "auto", padding: 8 } }, searching ? (react_2.default.createElement("div", { style: { padding: 16, color: palette.muted } }, "Pesquisando\u2026")) : query.trim() && results.length ? (results.map((item) => (react_2.default.createElement("a", { key: `${item.systemId}:${item.id}`, href: item.url, style: {
                        display: "block",
                        padding: "12px 14px",
                        borderRadius: 10,
                        color: palette.text,
                        textDecoration: "none",
                    } },
                    react_2.default.createElement("div", { style: { fontSize: 13, fontWeight: 600 } }, item.title),
                    item.subtitle ? (react_2.default.createElement("div", { style: {
                            marginTop: 3,
                            fontSize: 11,
                            color: palette.muted,
                        } }, item.subtitle)) : null)))) : query.trim() ? (react_2.default.createElement("div", { style: { padding: 16, color: palette.muted } }, "Nenhum resultado.")) : null)))) : null,
        settingsOpen ? (react_2.default.createElement(ModalShell, { title: "Configura\u00E7\u00F5es da conta", onClose: () => setSettingsOpen(false), dark: dark },
            react_2.default.createElement("label", { style: { display: "block", fontSize: 13, color: palette.text } },
                "Tema da plataforma",
                react_2.default.createElement("select", { value: theme, onChange: (e) => void setTheme(e.target.value), style: {
                        display: "block",
                        width: "100%",
                        height: 42,
                        marginTop: 8,
                        border: `1px solid ${palette.border}`,
                        borderRadius: 10,
                        padding: "0 10px",
                        background: palette.panel2,
                        color: palette.text,
                    } },
                    react_2.default.createElement("option", { value: "light" }, "Claro"),
                    react_2.default.createElement("option", { value: "dark" }, "Escuro"))))) : null,
        profileModalOpen && user ? (react_2.default.createElement(ModalShell, { title: "Perfil", onClose: () => setProfileModalOpen(false), dark: dark },
            react_2.default.createElement("div", { style: { display: "grid", gap: 10, color: palette.text } },
                react_2.default.createElement("div", null,
                    react_2.default.createElement("b", null, user.name)),
                react_2.default.createElement("div", { style: { color: palette.muted } }, user.email || "E-mail não informado"),
                businessContext ? (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement("div", null,
                        "Empresa: ",
                        businessContext.companyId,
                        " -",
                        " ",
                        businessContext.companyName || ""),
                    businessContext.branchId ? (react_2.default.createElement("div", null,
                        "Filial: ",
                        businessContext.branchId,
                        " -",
                        " ",
                        businessContext.branchName || "")) : null)) : null))) : null,
        (client === null || client === void 0 ? void 0 : client.getInvoices) ? (react_2.default.createElement(InvoicesModal_1.OktonInvoicesModal, { isOpen: invoicesOpen, onClose: () => setInvoicesOpen(false) })) : null,
        (client === null || client === void 0 ? void 0 : client.getBranches) && (client === null || client === void 0 ? void 0 : client.switchBranch) ? (react_2.default.createElement(BranchesModal_1.OktonBranchesModal, { isOpen: branchesOpen, onClose: () => setBranchesOpen(false) })) : null));
};
exports.OktonHeader = OktonHeader;
const kbdStyle = {
    minWidth: 28,
    height: 22,
    padding: "0 6px",
    border: "1px solid rgba(255,255,255,.55)",
    borderRadius: 5,
    background: "rgba(255,255,255,.92)",
    color: "#2B6CB0",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "inherit",
    fontSize: 10,
    fontWeight: 600,
};
const menuButton = {
    width: "100%",
    border: 0,
    background: "transparent",
    textAlign: "left",
    padding: "10px",
    fontSize: 13,
    cursor: "pointer",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    gap: 8,
};
const ModalShell = ({ title, onClose, dark, children }) => (react_2.default.createElement("div", { style: {
        position: "fixed",
        inset: 0,
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
    } },
    react_2.default.createElement("button", { type: "button", "aria-label": "Fechar", onClick: onClose, style: {
            position: "absolute",
            inset: 0,
            border: 0,
            background: "rgba(0,0,0,.5)",
        } }),
    react_2.default.createElement("div", { style: {
            position: "relative",
            width: "min(520px,100%)",
            background: dark ? "#1F2937" : "#fff",
            color: dark ? "#F7FAFC" : "#2D3748",
            borderRadius: 16,
            padding: 24,
            boxShadow: "0 20px 60px rgba(0,0,0,.25)",
        } },
        react_2.default.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 20,
            } },
            react_2.default.createElement("div", { style: { fontSize: 18, fontWeight: 700 } }, title),
            react_2.default.createElement("button", { type: "button", onClick: onClose, style: {
                    border: 0,
                    background: "transparent",
                    color: "inherit",
                    cursor: "pointer",
                } }, react_2.default.createElement(lu_1.LuX, { size: 20 }))),
        children)));
//# sourceMappingURL=index.js.map